/*globals Swiper*/
import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class JsSlider {
    static classname = 'js-slider';

    constructor($wrapper) {
        this.$wrapper = $wrapper;

        this.init();
    }

    init() {
        const $sliderWrapper = this.$wrapper;
        const slidesPerView = $sliderWrapper.attr('data-js-slides-per-view');
        const slidesPerViewMobileMedium = $sliderWrapper.attr('data-js-slides-per-view-medium');
        const slidesPerViewMobile = $sliderWrapper.attr('data-js-slides-per-view-mobile');
        const slidesPerViewTablet = $sliderWrapper.attr('data-js-slides-per-view-tablet');
        const slidesPerViewTabletSmall = $sliderWrapper.attr('data-js-slides-per-view-tablet-small');
        const autoHeight = $sliderWrapper.attr('data-js-autoheight');
        const spaceBetween = $sliderWrapper.attr('data-js-spaceBetween');
        const spaceBetweenMobile = $sliderWrapper.attr('data-js-spacebetween-mobile');
        const spaceBetweenTablet = $sliderWrapper.attr('data-js-spacebetween-tablet');
        const loop = $sliderWrapper.attr('data-js-loop');
        const $pagination = $sliderWrapper.find('.swiper-pagination');
        const $scrollbar = $sliderWrapper.find('.swiper-scrollbar');

        new Swiper($sliderWrapper.find('.swiper-container'), {
            preloadImages: false,
            slidesPerView: slidesPerView ? slidesPerView : 3,
            spaceBetween: spaceBetween ? spaceBetween : 30,
            autoHeight: autoHeight ? autoHeight : false,
            loop: loop ? loop : false,
            mousewheel: {
                forceToAxis: true
            },
            navigation: {
                nextEl: $sliderWrapper.find('.swiper-button-next, .block__title-btn_next'),
                prevEl: $sliderWrapper.find('.swiper-button-prev, .block__title-btn_prev')
            },
            pagination: {
                el: $pagination.length > 0 ? $pagination : null,
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 15,
            },
            scrollbar: {
                el: $scrollbar.length > 0 ? $scrollbar : null,
                draggable: true,
            },
            breakpoints: {
                1400: {
                    slidesPerView: slidesPerViewMobileMedium ? slidesPerViewMobileMedium : slidesPerView ? slidesPerView : 3,
                    spaceBetween: spaceBetween ? spaceBetween : 30
                },
                1200: {
                    slidesPerView: slidesPerViewTablet ? slidesPerViewTablet : 3,
                    spaceBetween: spaceBetweenTablet ? spaceBetweenTablet : 30
                },
                900: {
                    slidesPerView: slidesPerViewTabletSmall ? slidesPerViewTabletSmall : slidesPerViewTablet ? slidesPerViewTablet : 3,
                    spaceBetween: spaceBetweenTablet ? spaceBetweenTablet : 30
                },
                600: {
                    slidesPerView: slidesPerViewMobile ? slidesPerViewMobile : 1,
                    spaceBetween: spaceBetweenMobile ? spaceBetweenMobile : 15
                }
            }
        });
        $sliderWrapper.on('mousedown', '.swiper-button-next, .swiper-button-prev', function (e) {
            e.preventDefault();
        });
    }
}
